import { capitalize } from 'lodash';
import React from 'react';
import useMain from '../../../hooks/useMain';
import { numberWithCommas } from '../../../utils/helpers';
import Image from '../../common/image';
import NoData from '../../common/noData';
import MyPackagesTable from './packages/myPackagesTable';

const MaxCap = () => {
	const { userData } = useMain();
	const {
		class: userClass,
		userCards,
		maxCap,
		MMIMaxCap,
		mmi,
		totalCardsUsedMaxCap,
		MMIUsedMaxCap,
	} = userData;
	const totalUsedMaxCap = MMIUsedMaxCap + totalCardsUsedMaxCap;

	return (
		<div className='card myCards'>
			<div className='card-body'>
				<div className='row gy-4 my-4 text-center'>
					<div className='col-12'>
						<div className='fw-bold fs-2'>Max Cap Details</div>
					</div>
					<div className='offset-md-2 col-md-8 col-12 myInfoBox text-center'>
						<div className='centerAll'>
							<div className='me-3'>
								Class: <span className='fw-bold'>{capitalize(userClass)}</span>
							</div>
						</div>
						<hr />
						<div className='centerAll mmiSection'>
							<Image
								height='40px'
								fileName={`diamonds/mmi_${mmi.isActive}.webp`}
							/>
							<div className='mx-3'>
								MMI:{' '}
								<span className='fw-bold'>Is {!mmi.isActive && 'Not '}Active</span>
							</div>
							<div className='mx-3'>
								MMI Bonus Max Cap:{' '}
								<span className='fw-bold'>
									${numberWithCommas(MMIMaxCap / 1e6)}
								</span>
							</div>
							<div>
								MMI Used Max Cap:{' '}
								<span className='fw-bold'>
									${numberWithCommas(MMIUsedMaxCap / 1e6)}
								</span>
							</div>
						</div>
						<hr />
						<div className='centerAll maxCapSection'>
							<div>
								Total MaxCap:{' '}
								<span className='fw-bold'>${numberWithCommas(maxCap / 1e6)}</span>
							</div>
							<div className='mx-3'>
								Total Used MaxCap:{' '}
								<span className='fw-bold'>
									${numberWithCommas(totalUsedMaxCap / 1e6)}
								</span>
							</div>
							<div>
								Remaining MaxCap:{' '}
								<span className='fw-bold'>
									${numberWithCommas((maxCap - totalUsedMaxCap) / 1e6)}
								</span>
							</div>
						</div>
					</div>
					<div className='col-12'>
						<div className='fw-bold fs-5'>My Cards Table</div>
					</div>
					{userCards.length > 0 ? (
						<div className='offset-md-2 col-md-8 col-12'>
							<MyPackagesTable cards={userCards} />
						</div>
					) : (
						<NoData />
					)}
				</div>
			</div>
		</div>
	);
};

export default MaxCap;
